import { render, staticRenderFns } from "./FormTagSearch.vue?vue&type=template&id=557f3d67"
import script from "./FormTagSearch.vue?vue&type=script&lang=js"
export * from "./FormTagSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports